/* eslint-disable import/no-cycle */
import { connect } from 'react-redux';
import { goToLink } from 'redux-core/router/actions';
import { fetchBookmarkList } from 'redux-core/header/actions';

const mapDispatchToProps = { fetchBookmarkList, goToLink };

export default connect(undefined, mapDispatchToProps);
